module.exports = __webpack_public_path__ + "img/T5-A-rc_6.547d36de.png";